// Texto del usuario, conservado en su orden y sin asteriscos.
export const promiseLetter = {"theme":"healing",
    "recipient":  "Ali bonita",
    "title":  "Una promesa para la eternidad",
    "salutation":  "Para mi niña hermosa ❤️",
    "introHeading":  "Una promesa",
    "introEmphasis":  "para la eternidad.",
    "introCopy":  "Para ti, Ali. Un día a la vez.",
    "blocks":  [
                   {
                       "type":  "paragraph",
                       "text":  "No sé exactamente qué vaya a pasar de aquí al 6 de marzo. No puedo saber qué vas a sentir ese día, ni tampoco quiero asumir que por tener este tiempo significa que ya tengo asegurado un lugar a tu lado."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Lo único que sí sé es qué quiero hacer con cada uno de los días que hay de aquí hasta entonces."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Quiero demostrarte que puedo ser mejor."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "No solamente porque tenga miedo de perderte, sino porque después de todo lo que pasó entendí que amarte también significa hacerme responsable de la manera en la que mis acciones te hacen sentir. Entendí que decirte que te amo no sirve de mucho si mis actos alguna vez consiguen hacerte dudar precisamente de eso."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Y sé que te hice dudar."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Sé que lastimé algo que antes me entregabas con muchísima confianza. Sé que ahora hay cosas que quizá para mí pueden parecer pequeñas, pero que para ti despiertan preguntas, recuerdos, inseguridades o miedo de que vuelva a suceder lo mismo."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Y no quiero reclamarte por eso."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Fui yo quien provocó que hoy existieran esas dudas y, por lo mismo, quiero ser yo quien tenga la paciencia de ayudarte a que algún día dejen de existir."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "No quiero pedirte que olvides lo que pasó. Tampoco quiero apresurarte para que vuelvas a quererme de la misma manera que antes. Quiero respetar tu proceso y aprovechar esta oportunidad que me estás dando para demostrarte quién quiero ser contigo."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Porque este tiempo hasta el 6 de marzo no lo veo como una cuenta regresiva."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Lo veo como una oportunidad."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Una oportunidad para amarte mejor, para aprender a escucharte, para darte tranquilidad, para recuperar poco a poco tu confianza y para demostrarte que cuando digo que quiero una vida contigo no estoy hablando solamente desde la emoción del momento."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Quiero que mis palabras empiecen a tener el peso de mis acciones."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Quiero que algún día puedas mirar hacia atrás y darte cuenta de que no tuve que perderte definitivamente para aprender. Que fui capaz de reconocer mis errores, enfrentar las consecuencias y cambiar aquello de mí que estaba dañando a la persona que más amo."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Hay una frase de Morat que últimamente tiene muchísimo significado para mí:"
                   },
                   {
                       "type":  "paragraph",
                       "text":  "“Contra las apuestas, aquí nos quedamos.”"
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Y quisiera muchísimo que algún día esa frase hablara de nosotros."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "No porque nuestra historia haya sido perfecta."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Todo lo contrario."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Porque hubo un momento en el que parecía que todo estaba en nuestra contra. Porque nos lastimamos, porque hubo lágrimas, dudas, distancia y momentos en los que probablemente lo más fácil habría sido simplemente soltarnos."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Pero aun así hubo algo que nos hizo llegar hasta aquí."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Y ahora entiendo que quedarnos no significa simplemente seguir diciendo que somos novios."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Quedarnos significa escogernos."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Cuidarnos."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Respetarnos."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Volver a construir."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Y, sobre todo, hacer que valga la pena habernos dado otra oportunidad."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Por eso no quiero llegar al 6 de marzo con una lista de todas las cosas que hice bien esperando que por cumplirlas me hayas perdonado."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Quiero llegar a ese día y que tú misma puedas mirar estos meses y sentir que algo cambió."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Que el Joshua que tienes frente a ti aprendió."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Que ya no necesitas creer solamente en lo que te promete porque pudiste verlo en la forma en la que te trató, en cómo respetó tus límites, en cómo reaccionó cuando tuviste miedo, en cómo fue transparente contigo y en cómo decidió cuidarte incluso cuando nadie estaba mirando."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Quiero volver a ser un lugar bonito para ti."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Un lugar donde puedas sentir tranquilidad y no incertidumbre."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Y sé perfectamente que eso no puedo pedírtelo. Tengo que ganármelo."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Tal vez por eso también pienso mucho en todas esas canciones de Morat que hablan de amores complicados, de despedidas, de volver, de preguntarse qué habría pasado y de todas esas cosas que uno quisiera haber hecho diferente cuando todavía tenía tiempo."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Yo todavía tengo tiempo."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Tú me lo estás dando."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Y no pienso desperdiciarlo."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "No quiero que nuestra historia termine convirtiéndose en un “qué hubiera pasado si…”."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Quiero hacer todo lo que esté en mis manos para que cuando pensemos en nosotros podamos decir que tuvimos una etapa horrible, sí; que estuvimos a punto de perdernos, también; pero que decidimos hacer las cosas diferentes."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Y quiero dejar algo muy claro, mi amor:"
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Cambiar no significa dejar de ser yo para convertirme en la persona que tú quieres."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Significa corregir las partes de mí que hicieron daño a alguien que amo."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Significa madurar."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Significa entender que si quiero pedirte que compartas tu vida conmigo, también tengo que convertirme en alguien capaz de cuidar correctamente el corazón que me estás confiando."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Yo te quiero en mi futuro, Ali."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Te quiero en mis días normales, no solamente en los especiales."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Quiero tus mensajes, tus ocurrencias, tus enojos, tus “estás pendejo”, tus momentos cariñosos, nuestras tonterías, nuestras llamadas, nuestros detalles y hasta esos pequeños momentos que probablemente para cualquiera no significarían nada, pero que para mí tienen tu nombre."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Quiero seguir descubriendo versiones de ti."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Y quiero que tú puedas conocer una versión mejor de mí."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "No te puedo prometer perfección de aquí al 6 de marzo."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Pero sí puedo prometerte intención, constancia, honestidad, paciencia y hechos."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Especialmente hechos."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Porque ya entendí que algunas heridas no se curan escuchando cien veces “confía en mí”."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Se curan cuando pasa el tiempo y esa persona te demuestra cien veces que ahora sí puedes hacerlo."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Así quiero recuperar tu confianza."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Un día a la vez."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Sin exigirte nada."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Sin pedirte que avances más rápido."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Sin pensar que porque un día estemos muy bien significa que todo lo anterior desapareció."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Simplemente estando."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Demostrándote."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Escogiéndote."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Y amándote de una manera más consciente que antes."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "No sé qué me vas a responder el 6 de marzo."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Y probablemente esa incertidumbre me acompañe durante todos estos meses."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Pero hay algo que sí depende de mí: llegar a ese día sabiendo que hice todo lo posible para demostrarte cuánto significas para mí."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Y cuando llegue ese momento ya no necesite explicarte cuánto cambié."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Tú puedes verlo."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Puedes sentirlo."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Y entonces podamos mirar todo lo que atravesamos, todo lo que casi perdimos y todo lo que conseguimos reconstruir y decir, ahora sí, con una sonrisa:"
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Contra las apuestas, aquí nos quedamos. ❤️"
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Te amo, Ali."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Y esta vez quiero que no solamente lo escuches de mí."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Quiero que lo veas en mí."
                   },
                   {
                       "type":  "paragraph",
                       "text":  "Joshua ❤️"
                   }
               ]
};
